import { NgTemplateOutlet, TitleCasePipe } from '@angular/common';
import { Component, effect, input, output, signal, TemplateRef, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { TableColumnKey } from '../data-table.component';
import { DataHeaderAppliedFilter, DataHeaderFilter } from './data-header-filter.interface';

export type FilterRecord = Record<string, string | string[]>;

export interface FilterChangedDetection {
  filter: FilterRecord;
  changed: boolean;
}

@Component({
  selector: 'aura-data-header-filters',
  templateUrl: './data-header-filters.component.html',
  imports: [MatButton, MatMenuModule, MatIcon, MatTooltip, MatDivider, NgTemplateOutlet, TitleCasePipe],
  host: {
    '(window:keydown)': 'handleKeyboard($event)',
  },
})
export class AuraDataHeaderFilters<K extends string> {
  loading = input<boolean>();
  filters = input<DataHeaderFilter<TableColumnKey | K>[]>([]);
  mappedFilters = input<DataHeaderAppliedFilter<TableColumnKey | K>[]>();
  filterTemplate = input<TemplateRef<Record<string, unknown>> | null>(null);
  triggerFiltering = output<null>();
  clearFiltering = output<null>();
  removeFilter = output<{ value: string; key: TableColumnKey | K }>();
  filterView = output<string>();
  currentFilterView = signal<'main' | string>('main');

  constructor() {
    effect(() => {
      this.filterView.emit(this.currentFilterView());
    });
  }

  @ViewChild('filterTrigger') filterTrigger!: MatMenuTrigger;
  @ViewChild('columnTrigger') columnTrigger!: MatMenuTrigger;

  handleKeyboard(event: KeyboardEvent) {
    if (event.altKey && event.code === 'KeyF') {
      event.preventDefault();

      if (this.filterTrigger.menuOpen) {
        this.filterTrigger.closeMenu();
      } else {
        this.filterTrigger.openMenu();
      }
    }
  }

  openSubmenu(view: string) {
    this.currentFilterView.set(view);
  }

  back() {
    this.currentFilterView.set('main');
  }

  clearFilter() {
    this.clearFiltering.emit(null);
  }

  doApplyFilter() {
    //this.back();
    this.triggerFiltering.emit(null);
  }

  doRemoveFilter(key: TableColumnKey | K, value: string) {
    this.removeFilter.emit({ key, value });
    this.doApplyFilter();
  }
}
